/**
 * @generated SignedSource<<3beb819fdcd90274ad44625901d44cd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type VerticalType = "furniture" | "fashion" | "jewelry" | "art" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type freeShippingHelpers_item$data = {
  readonly vertical: VerticalType | null;
  readonly shipmentQuotes: ReadonlyArray<{
    readonly isComplimentary: boolean | null;
    readonly totalAmount: {
      readonly amount: number | null;
    } | null;
    readonly serviceMethod: {
      readonly region: {
        readonly regionName: string | null;
      } | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "freeShippingHelpers_item";
};
export type freeShippingHelpers_item$key = {
  readonly " $data"?: freeShippingHelpers_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"freeShippingHelpers_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "freeShippingHelpers_item"
};

(node as any).hash = "0f9f60d2da34f2b96f363fbf4179c2be";

export default node;
